/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActiveStep/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import AutopaymentComplete from './AutopaymentComplete/index'
import AutopaymentSetup from './AutopaymentSetup/index'
import DownpaymentComplete from './DownpaymentComplete/index'
import DownpaymentSetup from './DownpaymentSetup/index'
import Notes from './Notes/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ActiveStep({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Notes'
let payersActivetabViewValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.view',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: payersActivetabViewValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Notes'}>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DownpaymentSetup'}>
<DownpaymentSetup
  viewPath={`${viewPath}/DownpaymentSetup`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DownpaymentComplete'}>
<DownpaymentComplete
  viewPath={`${viewPath}/DownpaymentComplete`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AutopaymentSetup'}>
<AutopaymentSetup
  viewPath={`${viewPath}/AutopaymentSetup`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AutopaymentComplete'}>
<AutopaymentComplete
  viewPath={`${viewPath}/AutopaymentComplete`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}